import circle from "../../../../assets/icons/Ellipse 81.png";
import { Button1, Select, TagInput } from "../../../index";
import { Input } from "antd";
import FeeBreakdown from "../../../fee-breakdown/FeeBreakdown";

const fmt = (n, c) =>
  `${Number(n || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${c || ""}`.trim();

const CATEGORIES = ["Utilities", "Tax", "Telecom", "Insurance", "Other"];

const BillPaymentReview = ({
  sourceAccount,
  form,
  biller,
  quote,
  submitting,
  error,
  onConfirm,
  onClick,
}) => {
  const sourceCurrency = sourceAccount?.currency || "AUD";
  const billerName = biller?.name || biller?.fullName || biller?.businessName || "Manual Bill";

  const billPaymentReviewDetails = [
    { name: "Biller Name", info: billerName },
    { name: "CRN", info: form?.crn || "-" },
    { name: "Currency", info: sourceCurrency },
  ];

  const amountdetails = [
    {
      name: "Amount you want to send",
      info: fmt(form?.billAmount, sourceCurrency),
    },
    {
      name: "Transaction date",
      info: form?.transferDate
        ? new Date(form.transferDate).toLocaleDateString()
        : "Today",
    },
  ];

  return (
    <>
      <span className="fs-5 fw-medium">Review Your Transfer</span>

      <div className="col-lg-6 p-3 ">
        <div className="d-flex flex-column gap-3 rounded-3 p-3 border">
          <span className="fs14px fw-medium">Recipients</span>

          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex gap-2 align-items-center">
              <img src={circle} alt="biller" />
              <span className="fs14px fw-medium">{billerName}</span>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <span className="fs14px fw-medium">{sourceCurrency}</span>
            </div>
          </div>

          <div className="d-flex flex-column gap-1">
            <hr style={{ color: "#E3E3E3" }} />
            <div className="d-flex flex-column gap-3">
              {billPaymentReviewDetails.map(({ name, info }) => (
                <div key={name} className="d-flex justify-content-between">
                  <span className="fs12px" style={{ color: "#7D7D7D" }}>
                    {name}
                  </span>
                  <span className="fs12px">{info}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="d-flex flex-column gap-2 mt-3">
            {amountdetails.map(({ name, info }) => (
              <div key={name} className="d-flex flex-column gap-2">
                <span className="fs12px" style={{ color: "#7D7D7D" }}>
                  {name}
                </span>
                <div className="d-flex gap-2 align-items-center">
                  <span className="fw-medium">{info}</span>
                </div>
              </div>
            ))}
          </div>

          {quote && <FeeBreakdown quote={quote} kind="transfer" className="mt-2" />}
        </div>
      </div>

      <div className="col-lg-6 p-3">
        <div className="d-flex flex-column gap-3 rounded-3 p-3 border">
          <span className="fs14px fw-medium">Additional Details</span>

          <div className="d-flex flex-column gap-2">
            <label className="fs12px">
              Reference{" "}
              <span style={{ color: "#7D7D7D" }}>(Optional)</span>
            </label>
            <Input
              className="p-3"
              value={form?.crn || ""}
              disabled
            />
            <span className="fs12px fw-medium" style={{ color: "#7D7D7D" }}>
              Customer reference number
            </span>
          </div>

          <div className="d-flex flex-column gap-2">
            <label className="fs12px">Category</label>
            <Select
              value={form?.category}
              options={CATEGORIES.map((c) => ({ name: c, value: c }))}
              defaultValue="Choose Category"
              className="p-3"
              disabled
            />
          </div>

          <div className="d-flex flex-column gap-2">
            <label className="fs12px">Tags</label>
            <TagInput
              className="border py-3 "
              inputBgColor="transparent"
              tagColor="#1bbb6b"
              tagTextColor="#000"
              limit={10}
              placeholder="Add up to 10 Tags"
            />
          </div>
        </div>
      </div>

      {error && (
        <div className="col-12 p-2">
          <div className="fs12px" style={{ color: "#FC555B" }}>
            {error}
          </div>
        </div>
      )}

      <div className=" d-flex justify-content-md-end  justify-content-center flex-wrap p-2 gap-3">
        <Button1
          buttonName={"Previous"}
          className={"border"}
          onClick={() => onClick(0)}
        />
        <Button1
          buttonName={"Save as Draft"}
          className={"btn-outline-success"}
        />
        <Button1
          buttonName={submitting ? "Paying..." : "Create"}
          className="btn-dark "
          onClick={onConfirm}
          disabled={submitting}
        />
      </div>
    </>
  );
};

export default BillPaymentReview;
